import { css } from '@emotion/react';
import { type FC } from 'react';
import { PEGMAN_SAFE_OFFSET_PX } from '~/map/mapToolControls/mapOffsets.constants';
import { OverlappingUIPanelContainer } from '~/map/mapToolControls/menuItems/overlappingUI/overlappingUIPanel.container';
import { type StreetViewState } from '~/store/frontendState/mapTools/streetView/streetView.state';
import { type MapSettingsPublicMapSettingsState } from '~/store/mapSettings/publicMapSettings/mapSettingsPublicMapSettings.state';
import { topBarHeaderHeight } from '~/topBar/desktopTopBar.styles';
import { MapMarkersVisibilityToggleContainer } from '../menuItems/mapMarkersVisibilityToggle.container';
import { MapToolsMyLocationMenuItem } from '../menuItems/roundToolsButtonMenuItem/mapToolsMyLocationMenuItem.container';
import { ZoomControlsContainer } from '../menuItems/zoomControls/zoomControls.container';

// cannot cover the Google logo because of Google Maps TOS!
const BOTTOM_MARGIN = 30 + PEGMAN_SAFE_OFFSET_PX;
export const GOOGLE_LOGO_SAFE_OFFSET_PX = 66; // observed width of the Google Maps logo
const LEFT_OFFSET_PX = 10;
export const LEFT_SIDE_TOOLS_SAFE_OFFSET_PX = LEFT_OFFSET_PX + GOOGLE_LOGO_SAFE_OFFSET_PX;

const leftSideMapToolsStyle = css({
  position: 'absolute',
  bottom: BOTTOM_MARGIN,
  left: LEFT_OFFSET_PX,
  display: 'flex',
  flexDirection: 'column-reverse',
  gap: '8px',
  zIndex: 1,
  height: `calc(100% - ${topBarHeaderHeight}px - ${PEGMAN_SAFE_OFFSET_PX}px)`,
  pointerEvents: 'none',

  '& > *': {
    pointerEvents: 'auto',
  },
});

export const zoomControlsContainerStyle = css({
  breakInside: 'avoid',
  margin: '2px',
  position: 'relative',
});

type LeftSideMapToolsComponentProps = Readonly<{
  isMapPresentational: boolean;
  isMobileScreen: boolean;
  isMarkerVisibilityVisible?: boolean;
  publicMapSettings?: MapSettingsPublicMapSettingsState;
  streetView: StreetViewState;
}>;

export const LeftSideMapToolsComponent: FC<LeftSideMapToolsComponentProps> = (props) => {
  const showLocationMenu = props.isMobileScreen &&
    (!props.isMapPresentational || props.publicMapSettings?.showMyLocation);
  const showZoomControls = !props.isMapPresentational || props.publicMapSettings?.mapZoom;

  if (props.streetView.active) {
    return null;
  }

  return (
    <div css={leftSideMapToolsStyle}>
      {props.isMarkerVisibilityVisible && <MapMarkersVisibilityToggleContainer />}
      {showZoomControls && (
        <div css={zoomControlsContainerStyle}>
          <ZoomControlsContainer />
        </div>
      )}
      {showLocationMenu && <MapToolsMyLocationMenuItem />}
      <OverlappingUIPanelContainer />
    </div>
  );

};
